import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { submissionService } from '../../services/submissionService';
import ProfileHeader from './components/ProfileHeader';


export default function EmployeeProfileHub() {
  const { user, profile } = useAuth();
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user) {
      loadUserSubmissions();
    }
  }, [user]);

  const loadUserSubmissions = async () => {
    try {
      setLoading(true);
      const data = await submissionService?.getUserSubmissions(user?.id);
      setSubmissions(data);
    } catch (err) {
      setError(err?.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-xl">Loading your profile...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Profile Header */}
      <div className="mb-8">
        <ProfileHeader
          employee={profile}
          onEditProfile={() => console.log('Edit profile')} />
      </div>
      {error && (
        <div className="mb-4 p-4 bg-red-50 text-red-700 rounded-lg">
          {error}
        </div>
      )}
      <div className="container mx-auto">
        {/* Submissions List */}
        <div className="mt-6">
          <h2 className="text-2xl font-bold mb-4">Your Submissions</h2>
          {submissions?.length === 0 ? (
            <div className="bg-white p-6 rounded-lg text-center text-gray-500">
              No submissions yet. Start by selecting a company and filling the registration form.
            </div>
          ) : (
            <div className="space-y-4">
              {submissions?.map((submission) => (
                <div key={submission?.id} className="bg-white p-6 rounded-lg shadow">
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="text-lg font-semibold">{submission?.company?.name}</h3>
                      <p className="text-gray-600">Status: {submission?.submissionStatus}</p>
                      <p className="text-sm text-gray-500">
                        Submitted: {new Date(submission.submittedAt)?.toLocaleDateString()}
                      </p>
                    </div>
                    <span className={`px-3 py-1 rounded-full text-sm ${
                      submission?.submissionStatus === 'approved' ? 'bg-green-100 text-green-800' :
                      submission?.submissionStatus === 'rejected' ? 'bg-red-100 text-red-800' :
                      submission?.submissionStatus === 'under_review'? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800'
                    }`}>
                      {submission?.submissionStatus}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}